<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { messageStamp } from 'shared/helpers/timeHelper';
import { BaseTableRow, BaseTableCell } from 'dashboard/components-next/table';

defineProps({
  flow: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['open', 'delete', 'export']);

const readableDateWithTime = date =>
  messageStamp(new Date(date), 'LLL d, yyyy hh:mm:ss a');

const statusClass = status =>
  status === 'published'
    ? 'text-n-teal-11 bg-n-teal-2'
    : 'text-n-slate-12 bg-n-slate-4';
</script>

<template>
  <BaseTableRow :item="flow">
    <template #default>
      <BaseTableCell class="w-12 text-center rtl:pr-4 ltr:pl-4">
        <span class="text-body-main font-medium text-n-slate-12">
          {{ index }}
        </span>
      </BaseTableCell>

      <BaseTableCell class="w-[12rem] md:w-[14rem] max-w-0">
        <div class="flex flex-col min-w-0">
          <span class="font-medium text-body-main text-n-slate-12 truncate">
            {{ flow.name }}
          </span>
          <span class="mt-1 text-body-main text-n-slate-11 truncate">
            {{ flow.channel_type }}
          </span>
        </div>
      </BaseTableCell>

      <BaseTableCell class="w-24">
        <span
          class="inline-flex items-center text-xs rounded-md py-0.5 px-2 flex-shrink-0 capitalize"
          :class="statusClass(flow.status)"
        >
          {{ flow.status }}
        </span>
      </BaseTableCell>

      <BaseTableCell class="w-14 text-center">
        <span
          class="inline-flex items-center justify-center min-w-10 rounded-md bg-n-alpha-2 px-2 py-1 text-body-main text-n-slate-12 whitespace-nowrap"
        >
          {{ flow.inbox_id || '-' }}
        </span>
      </BaseTableCell>

      <BaseTableCell
        class="w-44"
        :title="readableDateWithTime(flow.updated_on)"
      >
        <span class="text-body-main text-n-slate-12 whitespace-nowrap">
          {{ readableDateWithTime(flow.updated_on) }}
        </span>
      </BaseTableCell>

      <BaseTableCell align="end" class="w-28 ltr:pr-4 rtl:pl-4">
        <div class="flex gap-2 justify-end flex-shrink-0">
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.OPEN')"
            icon="i-lucide-pencil"
            slate
            sm
            :is-loading="loading"
            @click="$emit('open', flow.id)"
          />
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.EXPORT_JSON')"
            icon="i-lucide-download"
            slate
            sm
            :is-loading="loading"
            @click="$emit('export', flow)"
          />
          <Button
            v-tooltip.top="$t('CONVERSATION_FLOWS.ACTIONS.DELETE')"
            icon="i-woot-bin"
            slate
            sm
            class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
            :is-loading="loading"
            @click="$emit('delete', flow)"
          />
        </div>
      </BaseTableCell>
    </template>
  </BaseTableRow>
</template>
